import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { postCreatePartner } from "../../api/Partners";
import toast from "react-hot-toast";
import LoadingTablePage from "../LoadingTablePage";
import PartnerForm from "../../components/partner/PartnerForm";

const CreatePartnerPage = () => {
  const { t } = useTranslation();
  const { getAccessToken } = useAuth(); 

  const navigate = useNavigate();
  const [loading] = useState(false);

  const [partner, setPartner] = useState({
    name: "", 
    organizationNumber: "", 
    email: "", 
    address: "", 
    zipCode: "", 
    city: "", 
    country: "", 
    phonePrefix: "", 
    phone: "", 
  });

  const handleInputChange = (key, value) => {
    setPartner((prev) => ({ ...prev, [key]: value }));
  };

  const handleCreateChargingPartner = async () => {
    const toastId = toast.loading(t("toast.creating", { entity: t("entity.partner") }));  

    try {
      const accessToken = await getAccessToken();
      if(!partner.startDateTimeUtc) {
        partner.startDateTimeUtc = new Date().toISOString();
      }
      const newPartner = await postCreatePartner(partner, accessToken);

      toast.success(t("toast.created", { entity: t("entity.partner") }), { id: toastId });

        navigate(`/partner/${newPartner.partnerPublicId}`);
      
    } catch (error) {
        toast.error(error?.message || t("toast.failedCreate", { entity: t("entity.partner") }), {
        id: toastId,
      });
    } 
  };

  const navigateBack = () => {
    if (navigate.length > 1) {
      navigate(-1);
    } else {
      navigate("/partners");
    }
  }

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute inset-0 pointer-events-none">
            <LoadingTablePage title={t("pages.createPartner")} loading={loading} />
          </div>

          <div className={`${loading ? "loading" : ""} page-content`}>
            <div className="flex flex-row items-center pb-4">
              <button
                onClick={() => navigateBack()}
                className="text-black flex"
              >
                <FontAwesomeIcon icon={faArrowLeft} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4 ">{t("pages.createPartner")}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigateBack()}
                >
                  {t("common.cancel")}
                </button>
                <button
                  className="btn btn-primary"
                  
                  onClick={handleCreateChargingPartner}
                >
                  {t("common.save")}
                </button>
              </div>
            </div>

            <PartnerForm
              partner={partner}
              handleInputChange={handleInputChange}
            />
          </div>
        </main>
      </div>
    </>
  );
};

export default CreatePartnerPage;
